module.exports = __webpack_public_path__ + "static/media/andini-staff-web-hubton.4b30ae89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/andini-staff-web-hubton.png
// module id = 176
// module chunks = 0